export default "__VITE_ASSET__BJFK0NHF__"